export default __webpack_public_path__ + "static/IBMPlexSans-Light-Cyrillic-4c3ed2a3f44451a96594e5808ac0439f.woff2";